import { getSniCodes } from 'App/enum/sniCodes';

// The code map itself lives in App/enum/sniCodes — this file only keeps it reachable through the
// Angular injector for attributes/lead2.js. Deleting it is WEB-7618.

angular.module('services.sniCodes', []).factory('SniCodes', () => ({ get: getSniCodes }));
